/**
 * Esse mixin deve ser incluído nos componentes de cada métrica dos Dashboards Personalizados
 * Ele fará de forma automática o processamento das data FROM e TO
 *
 * O componente DEVE possuir as variáveis:
 *  - selectedDateRange
 */
import subDays from 'date-fns/subDays';
import { getUnixStartOfDay, getUnixEndOfDay } from 'helpers/DateHelper';
import { DATE_RANGE_OPTIONS } from 'dashboard/routes/dashboard/settings/reports/constants';
import { GROUP_BY_FILTER } from '../../../constants.js';

export default {
  components: {},
  mixins: [],
  computed: {
    isDateRangeSelected() {
      return (
        this.selectedDateRange.id === DATE_RANGE_OPTIONS.CUSTOM_DATE_RANGE.id
      );
    },

    from() {
      if (this.isDateRangeSelected) return this.dateRange.range[0];

      const { offset } = this.selectedDateRange;
      const fromDate = subDays(new Date(), offset);
      return getUnixStartOfDay(fromDate);
    },
    to() {
      if (this.isDateRangeSelected) return this.dateRange.range[1];
      return getUnixEndOfDay(new Date());
    },

    groupBy() {
      // 1: Day, 2: Week, 3: Month, 4: Year
      const { id: rangeType } = this.selectedDateRange;
      if (rangeType === 'LAST_7_DAYS') return GROUP_BY_FILTER[1];
      if (rangeType === 'LAST_30_DAYS') return GROUP_BY_FILTER[2];
      if (['LAST_3_MONTHS', 'LAST_6_MONTHS', 'LAST_YEAR'].includes(rangeType))
        return GROUP_BY_FILTER[3];
      return this.correctGroupByBasedOnRange();
    },
  },
  mounted() {},
  methods: {
    getRequestPayload() {
      const { from, to, groupBy } = this;

      return {
        from,
        to,
        groupBy: groupBy?.period,
        businessHours: false,
      };
    },
    correctGroupByBasedOnRange() {
      const [from, to] = this.dateRange.range;
      const daysDiff = Math.floor((to - from) / (60 * 60 * 24));

      if (daysDiff > 729) return GROUP_BY_FILTER[4]; // Grouping by yaers if more than 729 days
      if (daysDiff > 59) return GROUP_BY_FILTER[3]; // Grouping by months if more than 59 days
      if (daysDiff > 13) return GROUP_BY_FILTER[2]; // Grouping by weeks if more than 13 days
      return GROUP_BY_FILTER[1];
    },
  },
};
